import {Image} from "@mantine/core";
import type {WareCategory} from "./types";

const DATACARD_BADGE_SRC = 'https://images.swcombine.com/items/31/main.jpg';
const DATACARD_BADGE_SIZE = 30;

interface WareImageProps {
    src?: string;
    alt: string;
    size: number;
    category?: WareCategory;
    radius?: string;
}

export default function WareImage({src, alt, size, category, radius = 'sm'}: WareImageProps) {
    return (
        <div style={{position: 'relative', width: size, height: size}}>
            <Image src={src} alt={alt} w={size} h={size} radius={radius} />
            {category === 'datacards' ? (
                <img
                    src={DATACARD_BADGE_SRC}
                    alt=""
                    aria-hidden="true"
                    width={DATACARD_BADGE_SIZE}
                    height={DATACARD_BADGE_SIZE}
                    style={{
                        position: 'absolute',
                        top: 2,
                        left: 2,
                        zIndex: 1,
                        pointerEvents: 'none',
                    }}
                />
            ) : null}
        </div>
    );
}
